<style type="text/css" scoped>
.nav_bar_d {
  border-right: 1.12px solid #E4E6EF;
  /* z-index: 300 !important; */
}

.nav_z_index {
  z-index: 300 !important;
}

.active_Select_org>>>.v-list-item--active {
  color: #FFA500;
}

.active_Select_Blue>>>.v-list-item--active {
  color: #4318FF;
}

.active_Select_adani>>>.v-list-item--active {
  /* color: #6C4ED9;    */
  color: linear-gradient(135deg, #0B74B0, #75479C, #BD3861);
}

.nav_bar_d>>>.v-navigation-drawer__content::-webkit-scrollbar {
  width: 2px;
  background-color: #f5f5f5;
}

.nav_bar_d>>>.v-navigation-drawer__content::-webkit-scrollbar-thumb {
  background-color: #4e4d4c;
  background-image: -webkit-linear-gradient(90deg,
      rgba(255, 255, 255, 0.2) 25%,
      transparent 25%,
      transparent 50%,
      rgba(255, 255, 255, 0.2) 50%,
      rgba(255, 255, 255, 0.2) 75%,
      transparent 75%,
      transparent);
}

.nav_bar_d>>>.v-navigation-drawer__content::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #f5f5f5;
}
</style>
<template>
  <div>
    <!-- Navigation Drawer (Side Menu) -->
    <v-navigation-drawer v-model="drawer" :mini-variant="true" app permanent fixed clipped
      class="nav_bar_d drawer-style" id="style-1" color="#FFFFFF"
      :class="menu_dialog ? 'nav_z_index' : ''" v-if="show_hide_mob_btn == 1&& !is_starr_menu_active">
      <v-list dense nav class="pa-2" :class="board_activ_select_cls">
        <v-list-item v-for="item in FullSideMENU" @click="open__dialog()" :key="item.title" link :class="[
          item.has_children ? '' : 'pl-0',
          item.is___select ? 'v-list-item--active mr-1' : '',
          !checkproductvalue(item) ? 'module-locked' : ''
        ]">
          <template v-if="item.has_children">
            <SideBarMenu :is_board_page="is_board_page" :is__adani_page="is__adani_page" :is__gmr_page="is__gmr_page"
              :is__vardhman_page="is__vardhman_page" :is__parle_page="is__parle_page"
              :is__granules_page="is__granules_page" :is__emami_page="is__emami_page" :ItemObj="item"
              type_menu="Children_Initial_Menu_Side" @to_close_MenuDialog="to_close_MenuDialog"/>
          </template>
          <template v-else>
            <SideBarMenu :is_board_page="is_board_page" :is__adani_page="is__adani_page" :is__gmr_page="is__gmr_page"
              :is__vardhman_page="is__vardhman_page" :is__parle_page="is__parle_page"
              :is__granules_page="is__granules_page" :is__emami_page="is__emami_page" :ItemObj="item"
              type_menu="Menu_Item_List_Menu_ICoN" @to_close_MenuDialog="to_close_MenuDialog"/>
          </template>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
import SideBarMenu from "@/components/Menu/SideBarMenu.vue";

import _STARR_MENU_ from "@/components/Menu/STARR_Menu.js";
import _Board_MENU_ from "@/components/Menu/BoardPage_Menu.js";
import _Family_MENU_ from "@/components/Menu/FamilyMenu.js";
export default {
  name: "NavSideBar",
  props: {
    is_board_page: {
      type: Boolean,
      default: false,
    },
    is__adani_page: {
      type: Boolean,
      default: false,
    },
    is__gmr_page: {
      type: Boolean,
      default: false,
    },
    is__vardhman_page: {
      type: Boolean,
      default: false,
    },
    is__parle_page: {
      type: Boolean,
      default: false,
    },
    is__granules_page: {
      type: Boolean,
      default: false,
    },
    is__emami_page: {
      type: Boolean,
      default: false,
    },
    is__family_page: {
      type: Boolean,
      default: false,
    },
    menu_dialog: {
      type: Boolean,
      default: false,
    },
    show_hide_mob_btn: {
      type: Number,
      default: 0,
    },
  },
  components: {
    SideBarMenu,
  },
  computed: {
    adani_activ_select_cls() {
      return this.is__adani_page ? 'active_Select_adani' : 'active_Select_org'
    },
    board_activ_select_cls() {
      return this.is_board_page ? this.adani_bg_cls : 'active_Select_Blue'
    },
  },
  mounted() {
    this.menu_load();
  },
  watch: {
    '$route.path'(newPath) {
      // console.log(newPath, 'newPath');
      this.$nextTick(() => {
        this.menu_load();
      });

    },
    is__family_page(newVal) {
      console.log('NavSideBar: is__family_page changed to:', newVal);
      this.$nextTick(() => {
        this.menu_load();
      });
    }
  },
  data() {
    return {
      FullSideMENU: [],
      username: localStorage.getItem("USER_NAME"),
      user_dep: 'Admin',
      drawer: true,
      menuItems: [],
      is_starr_menu_active: false,
    };
  },
  methods: {
    open__dialog() {
      if (this.is_board_page == true) {
        if (this.is__adani_page == true) {
          this.$emit('to_close_MenuDialog')

        } else if (this.is__gmr_page == true) {
          this.$emit('to_close_MenuDialog')
        } else if (this.is__vardhman_page == true) {
          this.$emit('to_close_MenuDialog')
        }
        else if (this.is__parle_page == true) {
          this.$emit('to_close_MenuDialog')
        }
        else {
          this.$emit('to_close_MenuDialog')
        }
      } else {
        this.$emit('to_close_MenuDialog')

      }
    },
    to_close_MenuDialog() {
      this.$emit('to_close_MenuDialog')
    },
    menu_load() {
      let TempMenuObj;
      // Check if logged in via FamilyBook
      const isFamilyBook = localStorage.getItem("is_family_book") === "true";

      console.log('NavSideBar menu_load:', {
        isFamilyBook,
        is__family_page: this.is__family_page,
        is_board_page: this.is_board_page,
        route_path: this.$route.path
      });

      this.is_starr_menu_active = false;

      const isPartner = localStorage.getItem("domain") === "partner";

      if (isPartner) {
        console.log('NavSideBar: Loading Partner Menu (STARR subset)');
        TempMenuObj = _STARR_MENU_;
      } else if (isFamilyBook || this.is__family_page) {
        console.log('NavSideBar: Loading Family Menu');
        TempMenuObj = _Family_MENU_;
      } else if (this.is_board_page) {
        console.log('NavSideBar: Loading Board Menu');
        TempMenuObj = _Board_MENU_;
      } else {
        console.log('NavSideBar: Loading STARR Menu');
        TempMenuObj = _STARR_MENU_;
        this.is_starr_menu_active = true;
      }
      const deepClone = obj => JSON.parse(JSON.stringify(obj));
      this.FullSideMENU = this.markSelectedByPath(deepClone(TempMenuObj.FullSideMENU), this.$route.path);
      console.log('NavSideBar: FullSideMENU loaded with', this.FullSideMENU.length, 'items');
    },
    markSelectedByPath(data, path) {
      function traverse(node) {
        let matched = false;

        if (node.children && node.children.length > 0) {
          node.children = node.children.map(child => {
            const result = traverse(child);
            if (result.matched) matched = true;
            return result.node;
          });

          node.is___select = matched ? true : null;
        } else {
          if (node.to === path) {
            node.is___select = true;
            matched = true;
          } else {
            node.is___select = null;
          }
        }

        return { node, matched };
      }

      return data.map(item => traverse(item).node);
    },

    checkproductvalue(item) {
      // Your existing checkproductvalue logic here
      var product_list = localStorage.getItem("tectalik_product_list");
      var domain = localStorage.getItem("domain");

      // Partner domain: show items flagged ispartnertoshow, or fall back to COMMON_SCREEN_RIGHT_DATASET
      if (domain === "partner") {
        if (item.ispartnertoshow) return true;
        let common_screens = JSON.parse(localStorage.getItem("COMMON_SCREEN_RIGHT_DATASET") || "[]");
        let screen_codeflag = item.screen_codeflag || [];
        if (!screen_codeflag.length || !common_screens.length) return false;
        let matched = common_screens.filter(s => screen_codeflag.indexOf(s.screen_code) !== -1);
        for (let i = 0; i < matched.length; i++) {
          if (matched[i].landing) return true;
        }
        return false;
      }
      var features_list = localStorage.getItem("features_list");

      let module_rights_dataset = JSON.parse(
        localStorage.getItem("MODULE_RIGHTS_DATASET")
      );
      let screen_right_dataset = JSON.parse(
        localStorage.getItem("SCREEN_RIGHT_DATASET")
      );

      let common_screen_right_dataset = JSON.parse(
        localStorage.getItem("COMMON_SCREEN_RIGHT_DATASET")
      );

      let flags_module = 0;
      let flags_screen = 0;
      var flags = 0;
      var features_flags = 0;
      var product_code = item.product_code;
      var screen_code = item.screen_code;

      let module_codeflag = [];
      let screen_codeflag = [];
      if (item.module_codeflag) {
        module_codeflag = item.module_codeflag;
      }
      if (item.screen_codeflag) {
        screen_codeflag = item.screen_codeflag;
      }

      let orolist = ["Customer_Target", "Customer_Report"];
      if (!["admin", "devadmin"].includes(domain)) {
        if (
          orolist.includes(item.name) &&
          domain != "oro" &&
          domain != "align"
        ) {
          return false;
        }

        if (item.isnonadmintoshow) {
          if (process.env.NODE_ENV === "production") {
            if (item.isproductiontohide) {
              return false;
            } else {
              return true;
            }
          } else {
            return true;
          }
        } else {
          if (!item.iscommontoshow) {
            if (process.env.NODE_ENV === "production") {
              if (item.isproductiontohide) {
                return false;
              }
            }
            if (
              product_list != null &&
              product_list != "" &&
              product_list != undefined &&
              product_list.length != 0
            ) {
              product_list = product_list.split(",");
              if (
                product_code != null &&
                product_code != "" &&
                product_code != undefined &&
                product_code.length != 0
              ) {
                let idex = product_list.filter(function (item) {
                  return product_code.indexOf(item) !== -1;
                });
                if (idex.length !== 0) {
                  flags++;
                }
              }
            }
            if (
              module_rights_dataset != null &&
              module_rights_dataset != "" &&
              module_rights_dataset != undefined &&
              module_rights_dataset.length != 0
            ) {
              var filteredmoudule = module_rights_dataset.filter(function (
                item
              ) {
                return module_codeflag.indexOf(item.module_code) !== -1;
              });
              for (var i = 0; i < filteredmoudule.length; i++) {
                if (filteredmoudule[i].active) {
                  flags_module++;
                  break;
                }
              }
            }
            if (
              screen_right_dataset != null &&
              screen_right_dataset != "" &&
              screen_right_dataset != undefined &&
              screen_right_dataset.length != 0
            ) {
              var filteredScreen = screen_right_dataset.filter(function (item) {
                return screen_codeflag.indexOf(item.screen_code) !== -1;
              });
              for (var i = 0; i < filteredScreen.length; i++) {
                if (filteredScreen[i].landing) {
                  flags_screen++;
                  break;
                }
              }
            }
            if (flags > 0 && flags_module > 0 && flags_screen > 0) {
              return true;
            } else {
              return false;
            }
          } else {
            return false;
          }
        }
      } else {
        if (!item.iscommontoshow) {
          let flags_screen = 0;
          if (
            common_screen_right_dataset != null &&
            common_screen_right_dataset != "" &&
            common_screen_right_dataset != undefined &&
            common_screen_right_dataset.length != 0
          ) {
            var filteredScreen = common_screen_right_dataset.filter(function (
              item
            ) {
              return screen_codeflag.indexOf(item.screen_code) !== -1;
            });
            for (var i = 0; i < filteredScreen.length; i++) {
              if (filteredScreen[i].landing) {
                flags_screen++;
                break;
              }
            }
          }

          if (flags_screen > 0) {
            return true;
          } else {
            return false;
          }
        } else {
          return true;
        }
      }
    },
  },
}
</script>